import { useContext } from 'react'
import { AuthContext } from '../contexts/AuthContext'
import UserService from "../services/utilisateurService"
const useUtilisateur = () => {
  
  const { api } = useContext(AuthContext)
  const service = new UserService(api)
  
  const getAllUser = async (params) => {
   return service.getAll(params)
  }

  const getOneUser = async (id) => {
    return service.getOne(id)
  }

  const updateOneUser = async (source, id, data) => {
    return service.update(source, id, data)
  }

  const createUser = async (source, data) => {
    return service.create(source, data)
  }

  return {
    getAllUser,
    getOneUser,
    updateOneUser,
    createUser
  }
}

export default useUtilisateur